<template>
    <div class="browser-messages" v-if="!isValid">
        <div class="browser-messages__inner">
            <template v-if="!isValidBrowser">
                Die Version Ihres Browsers wird leider nicht mehr unterstützt. Bitte stellen Sie
                sicher, dass Sie die aktuellste Version Ihres Browsers installiert haben.
            </template>
            <template v-else-if="!isValidSize">
                Um die Anwendung nutzen zu können, verwenden Sie bitte eine Bildschirmauflösung von
                mindestens 1024 x 640.<br />Sie benutzen momentan {{ curWidth }} x {{ curHeight }}.
            </template>
        </div>
    </div>
</template>

<script>
import bowser from 'bowser';

export default {
    data() {
        return {
            browser: null,
            windowWidth: null,
            windowHeight: null
        };
    },
    components: {},
    computed: {
        isValid() {
            return this.isValidBrowser && this.isValidSize;
        },
        isValidBrowser() {
            return this.browser === null || this.browser === true;
        },
        isValidSize() {
            return this.windowWidth >= 1024 && this.windowHeight >= 640; // leave room tabs etc.
        },
        curWidth() {
            return this.windowWidth;
        },
        curHeight() {
            return this.windowHeight;
        }
    },
    mounted() {
        let parsedBrowser = bowser.getParser(window.navigator.userAgent);
        this.browser = parsedBrowser.satisfies({
            safari: '>10',
            chrome: '>64',
            firefox: '>58',
            opera: '>51',
            'Microsoft Edge': '>17'
            //'Internet Explorer': '>=11'
        });
        this.$nextTick(() => {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
                this.windowHeight = window.innerHeight;
            });
        });
    },
    props: {}
};
</script>
